import * as React from "react";
const SvgBack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#111927"
      d="M17.227 3.687a1 1 0 0 0-1.454-1.374l-8.5 9a1 1 0 0 0 0 1.374l8.5 9.001a.999.999 0 1 0 1.454-1.373L9.375 12l7.852-8.313Z"
    />
  </svg>
);
export default SvgBack;